import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {OptionsMapper} from "@magieno/angular-advanced-forms";
import { AlertMessageStore } from '../../../../core/stores/alert-message.store';
import { SalaryDividendTaxQuestionnaireFormFactory } from './salary-dividend-tax-questionnaire-form.factory';
import { ClientQuestionnaireBase } from '../../base-client-questionnaire/form/base-form/client-questionnaire.base';

import { ClientQuestionnaireStore } from '../../../stores/client-questionnaire.store';
import {
  MainSpouseQuebec2023TaxQuestionnaireOptions,
} from '../../../../../../../../../common/src/options/client-questionnaire/quebec-2023-tax-questionnaire/main-spouse-quebec-2023-tax-questionnaire.options';
import { ErrorsUtils } from '../../../../core/utils/errors.utils';
import { LoggingService } from '../../../../core/services/logging.service';
import {
  SalaryDividendTaxQuestionnaireOptions,
} from '../../../../../../../../../common/src/options/client-questionnaire/salary-dividend/salary-dividend-tax-questionnaire.options';
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import {
  IncomeTaxPersonalOptions,
} from '../../../../../../../../../common/src/options/calculations/income-tax/personal/personal/income-tax-personal.options';
import {
  IncomeTaxPersonalSpouseOptions,
} from '../../../../../../../../../common/src/options/calculations/income-tax/personal/personal/income-tax-personal-spouse.options';
import {AdvancedFormArray} from "@magieno/angular-advanced-forms";
import {
  IncomeTaxPersonalChildOptions,
} from '../../../../../../../../../common/src/options/calculations/income-tax/personal/personal/income-tax-personal-child.options';
import {
  IncomeTaxPersonalChildCampOptions,
} from '../../../../../../../../../common/src/options/calculations/income-tax/personal/common/income-tax-personal-child-camp.options';
import {
  SalaryContributionsOptionsInSalaryDividendOptions,
} from '../../../../../../../../../common/src/options/calculations/salary-dividend/salary-contributions/salary-contributions-options-in-salary-dividend.options';
import { CompanyTypeEnum } from '../../../../../../../../../common/src/enums/company-type.enum';
import {
  CorporateIncomeTaxConnectedCorporationOptions,
} from '../../../../../../../../../common/src/options/calculations/income-tax/corporate/common/corporate-income-tax-connected-corporation.options';
import {
  IncomeTaxPersonalChildQuebecInIncomeTaxPersonalOptions,
} from '../../../../../../../../../common/src/options/calculations/income-tax/personal/personal/income-tax-personal-child-quebec-in-income-tax-personal.options';
import {
  IncomeTaxPersonalChildFederalInIncomeTaxPersonalOptions,
} from '../../../../../../../../../common/src/options/calculations/income-tax/personal/personal/income-tax-personal-child-federal-in-income-tax-personal.options';
import {
  CorporateIncomeTaxInSalaryDividendOptions,
} from '../../../../../../../../../common/src/options/calculations/salary-dividend/income-tax/corporate/corporate-income-tax-in-salary-dividend.options';

@Component({
  selector: 'app-salary-dividend-tax-questionnaire-form',
  templateUrl: './salary-dividend-tax-questionnaire-form.component.html',
  styleUrls: ['./salary-dividend-tax-questionnaire-form.component.scss'],
  standalone: false,
})
export class SalaryDividendTaxQuestionnaireFormComponent extends ClientQuestionnaireBase<SalaryDividendTaxQuestionnaireOptions> implements OnInit, OnDestroy {

  @Input()
  isReadOnly: boolean = false;

  subscriptions: Subscription[] = [];
  protected readonly AdvancedFormArray = AdvancedFormArray;
  protected readonly CompanyTypeEnum = CompanyTypeEnum;

  constructor(formFactory: SalaryDividendTaxQuestionnaireFormFactory,
              clientQuestionnaireStore: ClientQuestionnaireStore,
              translateService: TranslateService,
              activatedRoute: ActivatedRoute,
              modalService: NgbModal,
              router: Router,
              optionsMapper: OptionsMapper,
              // calculationsUtils: CalculationsUtils,
              alertMessageStore: AlertMessageStore,
              errorsUtils: ErrorsUtils,
              loggingService: LoggingService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
    super(formFactory, clientQuestionnaireStore, translateService, activatedRoute, modalService, router, optionsMapper, alertMessageStore, errorsUtils, loggingService);
    this.optionsType = MainSpouseQuebec2023TaxQuestionnaireOptions;
  }

  get mainPersonFormGroup(): AdvancedFormGroup<IncomeTaxPersonalSpouseOptions> {
    return this.incomeTaxPersonalOptionsFormGroup.formElements.mainPerson as AdvancedFormGroup<any>;
  }

  get spouseFormGroup(): AdvancedFormGroup<IncomeTaxPersonalSpouseOptions> {
    return this.incomeTaxPersonalOptionsFormGroup.formElements.spouse as AdvancedFormGroup<any>;
  }

  get childrenFormArray(): AdvancedFormArray<IncomeTaxPersonalChildOptions> {
    return this.incomeTaxPersonalOptionsFormGroup.formElements.children as AdvancedFormArray<IncomeTaxPersonalChildOptions>;
  }

  get incomeTaxPersonalOptionsFormGroup(): AdvancedFormGroup<IncomeTaxPersonalOptions> {
    return this.advancedForm.formElements.incomeTaxPersonalOptions as AdvancedFormGroup<any>;
  }

  get salaryContributionsOptionsFormGroup(): AdvancedFormGroup<SalaryContributionsOptionsInSalaryDividendOptions> {
    return this.advancedForm.formElements.salaryContributionsOptions as AdvancedFormGroup<SalaryContributionsOptionsInSalaryDividendOptions>;
  }

  get corporateIncomeTaxOptionsFormGroup(): AdvancedFormGroup<CorporateIncomeTaxInSalaryDividendOptions> {
    return this.advancedForm.formElements.corporateIncomeTaxOptions as AdvancedFormGroup<CorporateIncomeTaxInSalaryDividendOptions>;
  }

  get connectedCorporationsFormArray(): AdvancedFormArray<CorporateIncomeTaxConnectedCorporationOptions> {
    return this.corporateIncomeTaxOptionsFormGroup.formElements.connectedCorporations as AdvancedFormArray<CorporateIncomeTaxConnectedCorporationOptions>;
  }

  override ngOnInit(): void {
    super.ngOnInit();

    if (this.isReadOnly) {
      this.advancedForm.disable();
    }

    this.subscriptions.push(this.advancedForm.formElements.isMarried.value$.subscribe((value) => {
      this.incomeTaxPersonalOptionsFormGroup.formElements.isMarried.setValue(value.value);
    }));
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

  getIncomeTaxPersonalChildQuebecFormGroup(childFormGroup: AdvancedFormGroup<IncomeTaxPersonalChildOptions>): AdvancedFormGroup<IncomeTaxPersonalChildQuebecInIncomeTaxPersonalOptions> {
    return childFormGroup.formElements.quebec as AdvancedFormGroup<IncomeTaxPersonalChildQuebecInIncomeTaxPersonalOptions>;
  }

  getIncomeTaxPersonalChildFederalFormGroup(childFormGroup: AdvancedFormGroup<IncomeTaxPersonalChildOptions>): AdvancedFormGroup<IncomeTaxPersonalChildFederalInIncomeTaxPersonalOptions> {
    return childFormGroup.formElements.federal as AdvancedFormGroup<IncomeTaxPersonalChildFederalInIncomeTaxPersonalOptions>;
  }

  getChildCamps(childFormGroup: AdvancedFormGroup<IncomeTaxPersonalChildOptions>): AdvancedFormArray<IncomeTaxPersonalChildCampOptions> {
    return childFormGroup.formElements.camps as AdvancedFormArray<IncomeTaxPersonalChildCampOptions>;
  }

  addChild() {
    this.childrenFormArray.appendNew();
  }
}

